<template>
  <div>
    <div class="card-body">
      <selectlist
        :options="statuses"
        label="Status"
        name="status_id"
        placeholder="Please Select"
        label-name="label"
        key-name="id"
        v-model="recoveryForm.status_id"
        :show-error="recoveryForm.errors.has('status_id')"
        :error-message="recoveryForm.errors.get('status_id')"
      ></selectlist>

      <div class="form-group">
        <div class="col-lg-4">
          <label class="control-label">Outstanding Claim Reason (OCR):</label>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-6">
              <selectlist
                stacked
                :options="outstandingClaimReasonCategories"
                name="outstanding_claim_reason_category_id"
                placeholder="Please Select"
                label-name="label"
                key-name="id"
                v-model="selectedOutstandingClaimReasonCategoryId"
              ></selectlist>
            </div>
            <div class="col-lg-6">
              <selectlist
                stacked
                :options="outstandingClaimReasons"
                name="outstanding_claim_reason_id"
                placeholder="Please Select"
                label-name="label"
                key-name="id"
                v-model="recoveryForm.outstanding_claim_reason_id"
              ></selectlist>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>

      <selectlist
        :options="reasonsNotIssued"
        label="Reason Not Issued (RNI)"
        name="reason_not_issued_id"
        placeholder="Please Select"
        label-name="label"
        key-name="id"
        v-model="recoveryForm.reason_not_issued_id"
      ></selectlist>

      <div class="form-group">
        <div class="col-lg-4">
          <label class="control-label">Is GTA?</label>
        </div>
        <div class="col-lg-8">
          <toggleswitch
            :labels="true"
            name="is_gta"
            v-model="recoveryForm.is_gta"
          ></toggleswitch>
        </div>
      </div>

      <div class="form-group">
        <div class="col-lg-4">
          <label class="control-label">Should Payments Include VAT?</label>
        </div>
        <div class="col-lg-8">
          <toggleswitch
            :labels="true"
            name="is_gta"
            v-model="recoveryForm.include_vat"
          ></toggleswitch>
        </div>
      </div>

      <company-select
        v-if="companyLoaded"
        id="reference-company"
        :company="solicitorForm"
        ref="companySelector"
        heading="Solicitor"
        helper="Enter the details of solicitor"
        :types="solicitorTypes"
      ></company-select>

      <inputbox
        v-model="solicitorForm.solicitors_reference"
        name="solicitors_reference"
        helper="Please enter the solicitors reference"
        label="Solicitors Reference"
      ></inputbox>

      <div class="text-right">
        <form-button :indicator="processing" @clicked="submit">
          Save
        </form-button>
      </div>

      <fieldset>
        <legend>Global Offer</legend>

        <div class="form-group">
          <div class="col-lg-4">
            <label class="control-label">Made A Global Offer?</label>
          </div>
          <div class="col-lg-8">
            <toggleswitch
              :labels="true"
              helper="Have you made a global offer?"
              name="global_offer_enabled"
              v-model="recoveryForm.global_offer_enabled"
            ></toggleswitch>
          </div>
        </div>

        <template v-if="recoveryForm.global_offer_enabled">
          <currency-input
            name="global_offer"
            label="Global Offer"
            v-model="recoveryForm.global_offer"
            helper="Please enter the global offer"
            :show-error="recoveryForm.errors.has('global_offer')"
            :error-message="recoveryForm.errors.get('global_offer')"
          ></currency-input>

          <div class="form-group">
            <div class="col-lg-4">
              <label class="control-label">Global Offer Accepted</label>
            </div>
            <div class="col-lg-8">
              <toggleswitch
                :labels="true"
                helper="Has the global offer been accepted?"
                name="global_offer_accepted"
                v-model="recoveryForm.global_offer_accepted"
              ></toggleswitch>
            </div>
          </div>
        </template>

        <div class="text-right">
          <form-button :indicator="processing" @clicked="submit">
            Save
          </form-button>
        </div>
      </fieldset>

      <template v-if="hasHire">
        <fieldset>
          <legend>Hire Days</legend>

          <inputbox
            name="total_days"
            type="number"
            :stacked="false"
            label="Total Days"
            :readonly="true"
            :value="hireForm.total_days"
            :show-error="hireForm.errors.has('total_days')"
            :error-message="hireForm.errors.get('total_days')"
          ></inputbox>

          <inputbox
            name="total_days_agreed"
            type="number"
            :stacked="false"
            label="Total Days Agreed"
            v-model="hireForm.total_days_agreed"
            :show-error="hireForm.errors.has('total_days_agreed')"
            :error-message="hireForm.errors.get('total_days_agreed')"
          ></inputbox>

          <selectlist
            :options="holdBackReasons"
            label="Hold Back Reason"
            name="hold_back_reason_id"
            placeholder="Please Select"
            :required="true"
            label-name="label"
            key-name="id"
            v-model="hireForm.hold_back_reason_id"
            :show-error="hireForm.errors.has('hold_back_reason_id')"
            :error-message="hireForm.errors.get('hold_back_reason_id')"
            v-if="
              hireForm.total_days_agreed &&
                hireForm.total_days > hireForm.total_days_agreed
            "
          ></selectlist>

          <div class="text-right col-12">
            <form-button
              :indicator="hireForm.processing()"
              @clicked="submitHire"
            >
              Save Hire Days
            </form-button>
          </div>
        </fieldset>
      </template>

      <hr />

      <invoices
        :incident="incident"
        :recovery="recovery"
        :rate-groups="rateGroups"
        v-if="hasPermission('invoices.read')"
      ></invoices>

      <fieldset>
        <legend>Rates</legend>

        <table class="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Daily Rate</th>
              <th>Days</th>
              <template v-if="recoveryForm.is_gta">
                <th>Early Payment</th>
                <th>GTA Rate</th>
                <th>GTA Rate + LPP</th>
                <th>Commercial Rate</th>
              </template>
              <template v-if="!recoveryForm.is_gta">
                <th>Rate</th>
              </template>
              <th>Agreed Figure</th>
              <th>Amount Paid</th>
              <th>Short Fall Reason</th>
              <th></th>
            </tr>
          </thead>
          <template v-for="(group, groupIndex) in rateGroups">
            <tbody :key="`rate-groups-${groupIndex}`">
              <tr class="table-info">
                <th colspan="15">{{ group.label }}</th>
              </tr>

              <template v-for="(rate, rateIndex) in groupRates(group)">
                <gta-row
                  :rate="rate"
                  :group="group"
                  :rates-form="ratesForm"
                  :hire-form="hireForm"
                  :key="`rate-${rateIndex}`"
                  @remove="removeRate(rate)"
                  v-if="recoveryForm.is_gta"
                ></gta-row>

                <non-gta-row
                  :rate="rate"
                  :group="group"
                  :rates-form="ratesForm"
                  :hire-form="hireForm"
                  :key="`rate-${rateIndex}`"
                  @remove="removeRate(rate)"
                  v-else
                ></non-gta-row>
              </template>

              <tr>
                <td colspan="15">
                  <button
                    type="button"
                    class="btn btn-xs btn-block btn-info"
                    @click="addHeadOfClaim(group)"
                  >
                    Add Head Of Claim
                  </button>
                </td>
              </tr>
            </tbody>

            <gta-totals
              :rates="groupRates(group)"
              :totals="recovery.totals"
              :group="group"
              :vat-registered="recoveryForm.include_vat"
              :key="`gta-totals-rate-group-${groupIndex}`"
              v-if="recoveryForm.is_gta"
            ></gta-totals>

            <non-gta-totals
              :rates="groupRates(group)"
              :totals="recovery.totals"
              :group="group"
              :vat-registered="recoveryForm.include_vat"
              :key="`non-gta-totals-rate-groups-${groupIndex}`"
              v-else
            ></non-gta-totals>
          </template>
        </table>
      </fieldset>
    </div>

    <div class="card-footer text-right">
      <form-button :indicator="processing" @clicked="submit">
        Save
      </form-button>
    </div>
  </div>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';
import GTARow from '@/components/Modules/Recovery/Sections/Figures/GTARow';
import GTATotals from '@/components/Modules/Recovery/Sections/Figures/GTATotals';
import NonGTARow from '@/components/Modules/Recovery/Sections/Figures/NonGTARow';
import NonGTATotals from '@/components/Modules/Recovery/Sections/Figures/NonGTATotals';
import Invoices from '@/components/Modules/Recovery/Sections/Figures/Invoices';
import Company from '@/components/Modules/Shared/Company.vue';

let headOfClaimId = 0;

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    },
    recoveryForm: {
      type: Object,
      required: true
    },
    hireForm: {
      type: Object,
      required: true
    },
    ratesForm: {
      type: Object,
      required: true
    },
    hireMonitoring: {
      type: Object
    },
    hasHire: {
      type: Boolean
    }
  },

  components: {
    CurrencyInput,
    Invoices,
    'gta-row': GTARow,
    'gta-totals': GTATotals,
    'non-gta-row': NonGTARow,
    'non-gta-totals': NonGTATotals,
    'company-select': Company
  },

  data() {
    return {
      processing: false,
      companyLoaded: false,
      solicitorForm: new window.Form({
        company_id: null,
        name: null,
        email_address: null,
        telephone_number: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        solicitors_reference: null
      }),
      solicitorTypes: ['solicitor']
    };
  },

  computed: {
    getClaimType() {
      if (this.hireMonitoring && this.hireMonitoring.claim_type) {
        return this.hireMonitoring.claim_type.name;
      }

      return null;
    },

    holdBackReasons() {
      return this.$store.getters['HoldBackReasons/all'];
    },

    outstandingClaimReasonCategories() {
      return this.$store.getters['OutstandingClaimReasons/all'];
    },

    outstandingClaimReasons() {
      const category = this.outstandingClaimReasonCategories.find(
        category =>
          category.id === this.recoveryForm.outstanding_claim_reason_category_id
      );

      return category && category.reasons ? category.reasons : [];
    },

    selectedOutstandingClaimReasonCategoryId: {
      get() {
        return this.recoveryForm.outstanding_claim_reason_category_id;
      },
      set(value) {
        this.recoveryForm.outstanding_claim_reason_category_id = value;
        this.recoveryForm.outstanding_claim_reason_id = null;
      }
    },

    reasonsNotIssued() {
      return this.$store.getters['ReasonNotIssued/all'];
    },

    rateGroups() {
      return this.$store.getters['RateGroups/all'];
    },

    statuses() {
      return this.$store.getters['DebtRecoveryStatuses/all'];
    },

    source() {
      return this.$store.getters['Incident/source'];
    }
  },

  mounted() {
    this.setSourceDetails(this.source);

    this.companyLoaded = true;
  },

  methods: {
    submit() {
      this.processing = true;

      this.recoveryForm
        .put(`debt-recovery/${this.incident}`)
        .then(response => {
          this.recovery.is_gta = response.is_gta || false;
          this.recovery.include_vat = response.include_vat || false;
          this.recovery.solicitors_reference =
            response.solicitors_reference || null;

          const rates = Object.values(
            JSON.parse(JSON.stringify(this.ratesForm.rates))
          ).map(rate => {
            if (typeof rate.id === 'string' && rate.id.startsWith('customId')) {
              delete rate.id;
            }

            return rate;
          });

          window.Ajax.put(`debt-recovery/${this.incident}/rates`, { rates })
            .then(response => {
              this.processing = false;

              this.recovery.rates = response.data.rates;
              this.recovery.totals = response.data.totals;
              this.ratesForm.rates = {};

              response.data.rates.forEach(rate => {
                this.ratesForm.rates[rate.id] = rate;
              });

              window.toastify.success(
                'Success!',
                'The recovery was saved successfully!'
              );
            })
            .catch(err => {
              this.processing = false;

              window.toastify.error(
                'Error',
                'Sorry, there was an error saving the rates'
              );
            });
        })
        .catch(err => {
          this.processing = false;

          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the recovery'
          );
        });

      window.Ajax.put(`incidents/${this.incident}/source`, {
        ...this.source,
        solicitor_id: this.$refs.companySelector.form.company_id,
        solicitor_name: this.$refs.companySelector.form.name,
        solicitor_email_address: this.$refs.companySelector.form.email_address,
        solicitor_telephone_number: this.$refs.companySelector.form
          .telephone_number,
        solicitor_address_line_one: this.$refs.companySelector.form
          .address_line_one,
        solicitor_address_line_two: this.$refs.companySelector.form
          .address_line_two,
        solicitor_city: this.$refs.companySelector.form.city,
        solicitor_postcode: this.$refs.companySelector.form.postcode,
        solicitors_reference: this.solicitorForm.solicitors_reference
      })
        .then(response => {
          this.$store.commit('Incident/setSource', response.data);
        })
        .catch(err => {
          this.processing = false;

          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the solicitor details'
          );
        });
    },

    submitHire() {
      this.hireForm
        .put(`debt-recovery/${this.incident}/hire`)
        .then(response => {
          response.rates.forEach(rate => {
            this.ratesForm.rates[rate.id] = rate;
          });

          this.$forceUpdate();

          window.toastify.success(
            'Success!',
            'The hire days were updated successfully!'
          );
        })
        .catch(err => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the hire days'
          );
        });
    },

    groupRates(group) {
      return Object.values(this.ratesForm?.rates || {}).filter(
        rate => rate.rate_group_id === group.id
      );
    },

    addHeadOfClaim(group) {
      headOfClaimId++;

      const id = `customId-${headOfClaimId}`;

      this.ratesForm.rates[id] = {
        id,
        rate_group_id: group.id,
        short_fall_reason_id: null,
        name: null,
        label: null,
        value: null,
        commercial_rate: null,
        agreed_value: null
      };

      this.$forceUpdate();
    },

    removeRate(rate) {
      window
        .swal({
          title: 'Are you sure you want to remove that head of claim?',
          type: 'warning',
          showCancelButton: true
        })
        .then(
          () => {
            delete this.ratesForm.rates[rate.id];

            this.$forceUpdate();
          },
          dismiss => {}
        );
    },

    setSourceDetails(source) {
      this.solicitorForm.company_id = source.solicitor_id;
      this.solicitorForm.name = source.solicitor_name;
      this.solicitorForm.email_address = source.solicitor_email_address;
      this.solicitorForm.telephone_number = source.solicitor_telephone_number;
      this.solicitorForm.address_line_one = source.solicitor_address_line_one;
      this.solicitorForm.address_line_two = source.solicitor_address_line_two;
      this.solicitorForm.city = source.solicitor_city;
      this.solicitorForm.solicitors_reference = source.solicitors_reference;
    }
  },

  watch: {
    source(source) {
      if (source) {
        this.setSourceDetails(source);
      }
    }
  }
};
</script>
